import { logger } from '../core/logger';
import { environment } from '../environments/environment';
import { loadScript } from '../utils/mfe-loader';
import '../types/__global';

/**
 * Loads and initializes the fraud bootstrap script
 */
export const initializeFraudBootstrap = (): void => {
  loadScript(environment.fraudBootstrapScriptUrl);

  const waitForFraudBootstrap = (): Promise<void> => {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (globalThis.FRAUDBOOTSTRAP) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
    });
  };

  waitForFraudBootstrap()
    .then(() => {
      globalThis.FRAUDBOOTSTRAP?.initializeFraudV2(environment.paymentsPanelApiUrl);
      logger.info('FraudBootstrap script loaded and initialized successfully');
    })
    .catch((error) => {
      logger.error('Error loading FraudBootstrap script:', error);
    });
};
